export const getPreviousDate = (currentDate: Date): Date => {
  const clonedDate = new Date(JSON.parse(JSON.stringify(currentDate)));
  return new Date(clonedDate.setDate(clonedDate.getDate() - 1));
};
export const getNextDate = (currentDate: Date): Date => {
  const clonedDate = new Date(JSON.parse(JSON.stringify(currentDate)));
  return new Date(clonedDate.setDate(clonedDate.getDate() + 1));
};
